import {Component, ElementRef, HostListener, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'lib-screen-iphone',
    templateUrl: './screen-iphone.component.html',
    styleUrls: ['./screen-iphone.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScreenIphoneComponent implements OnInit {

  @Input() url;
  @Input() point;
  @Input() imageSize;
  widthPhoto = 100;
  heightPhoto = 100;
  leftPhoto = 235;
  topPhoto = 39;

  constructor(private iphone: ElementRef<HTMLElement>) {
  }

  @HostListener('window:resize') resize() {
    this.calc();
  }

  ngOnInit() {
    this.calc();
  }

  calc() {
    const {height, width} = this.iphone.nativeElement.getBoundingClientRect();
    console.log('wysokość kontenera', height, 'szerokość kontenera', width);
    if (height > width / 1.98) {
      this.widthPhoto = width * .21;
      this.heightPhoto = width / 1.98 * .73;
    }
    if (height <= width / 1.98) {
      this.heightPhoto = height * .73;
      this.widthPhoto = height * 1.98 * .21;
    }

    this.topPhoto = (height - this.heightPhoto) / 2 - this.heightPhoto / 200;
    this.leftPhoto = (width - this.widthPhoto) / 2;
    console.log('wysokość zdjecia', this.heightPhoto, 'szerokość zdjecia', this.widthPhoto);
    console.log('top zdjecia', this.topPhoto, 'left zdjecia', this.leftPhoto);
  }
}
